/**
 * @file PickMarkProgress.tsx
 * @description Прогресс задания в панели отметки (phase19.24 §3.2; исходы
 * убраны из панели в этапе 1, шаг 1).
 *
 * Метрика одна — позиции: «Собрано 1 из 3 позиций», полоса, «Осталось: 2
 * позиции» и строка про недостачи. Раньше то же место показывало единицы, и
 * «собрано 0 / 2» на одной позиции читалось как «ничего не собрано» при
 * полностью закрытом задании.
 *
 * Кнопки «Оформить недостачу» здесь больше нет: по конвенции шапки исход
 * задания — главное действие документа, и живёт он в одном месте (шапка на
 * `≥lg`, sticky-бар на `<lg`). Две кнопки одного действия на экране спорили
 * друг с другом.
 */

import {
  formatPickedPositions,
  formatRemainingPositions,
  formatShortagePositions,
  pickedPercent,
} from "../../../lib/picking-format";

interface Props {
  picked: number;
  total: number;
  /** Строк, закрытых недостачей. */
  shortageCount: number;
}

export function PickMarkProgress({ picked, total, shortageCount }: Props) {
  const percent = pickedPercent(picked, total);
  return (
    <div className="flex flex-col gap-2 border-t border-on-surface/8 pt-3">
      <p className="text-sm font-medium tabular-nums">
        Собрано {formatPickedPositions(picked, total)}
      </p>
      <div
        role="progressbar"
        aria-valuenow={percent}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label="Прогресс сборки"
        className="h-2 overflow-hidden rounded-full bg-surface-low"
      >
        <div
          className="h-full rounded-full bg-primary transition-[width] duration-300"
          style={{ width: `${percent}%` }}
        />
      </div>
      <p className="text-xs text-on-surface-variant">
        {formatRemainingPositions(picked, total)}
      </p>
      {shortageCount > 0 ? (
        <p className="text-xs text-destructive">
          {formatShortagePositions(shortageCount)}
        </p>
      ) : null}
    </div>
  );
}
